export default __webpack_public_path__ + "static/media/pipeline_gears.6ce47802.gif";